import { useEffect, useRef } from 'react';

/**
 * "Cidade fixa na busca" — tbl_sites.CidadeBusca, configurada no CRM em
 * Personalizar site → Comportamento (era "Cidade Selecionada Busca" do atualiza.php).
 *
 * Quando o visitante ABRE o site, o formulário de busca já vem com essa cidade
 * selecionada — em vez de "Cidade" vazio. Não confundir com `site.cidade_priorizada`
 * (CidadesPriorizadas), que só ORDENA a lista do select.
 *
 * Regras:
 *  - aplica UMA vez, no primeiro render em que a lista de cidades já chegou;
 *  - não mexe se o formulário já tem cidade (usuário escolheu, veio da URL, ou o site
 *    só tem uma cidade e o auto-select já rodou) — trocar/limpar depois continua valendo;
 *  - cidade configurada que não está na lista do site (sem imóvel publicado) é ignorada
 *    em silêncio: o formulário abre vazio, como antes.
 */
export function useCidadeFixaBusca(
    cidadeBusca: unknown,
    cities: Array<any> | undefined | null,
    jaTemCidade: boolean,
    aplicar: (cidade: any) => void,
) {
    const jaAplicou = useRef(false);

    useEffect(() => {
        if (jaAplicou.current) return;
        const id = Number(cidadeBusca || 0);
        if (!id) return;
        if (jaTemCidade) {
            jaAplicou.current = true;
            return;
        }
        if (!cities?.length) return; // lista ainda não chegou — tenta no próximo render
        const cidade = cities.find((c: any) => Number(c?.value) === id);
        jaAplicou.current = true;
        if (cidade) aplicar(cidade);
    }, [cidadeBusca, cities, jaTemCidade, aplicar]);
}
